"use client";

import { Collapsible as CollapsiblePrimitive } from "@base-ui/react/collapsible";
import { ChevronDownIcon } from "lucide-react";
import type { ComponentProps } from "react";

const Collapsible = CollapsiblePrimitive.Root;

function CollapsibleTrigger({
  children,
  showCaret = false,
  ...props
}: ComponentProps<typeof CollapsiblePrimitive.Trigger> & {
  showCaret?: boolean;
}) {
  return (
    <CollapsiblePrimitive.Trigger {...props}>
      {children}
      {showCaret && (
        <ChevronDownIcon
          aria-hidden="true"
          className="size-4 shrink-0 transition-transform motion-reduce:transition-none [[data-closed]>&]:-rotate-90"
        />
      )}
    </CollapsiblePrimitive.Trigger>
  );
}

const CollapsibleContent = CollapsiblePrimitive.Panel;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
